import React from "react";
import { CEF_LINKS } from "@/lib/cef-links";

const WhatsAppIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.86 9.86 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.84 9.84 0 0 0 12.04 2Zm5.83 14.04c-.25.7-1.43 1.33-2.01 1.42-.51.07-1.18.11-1.9-.12-.44-.14-1-.32-1.72-.63-3.03-1.31-5-4.36-5.16-4.56-.15-.2-1.22-1.62-1.22-3.09 0-1.47.77-2.19 1.04-2.49.27-.3.59-.37.79-.37l.57.01c.18.01.43-.07.67.51.25.6.84 2.07.92 2.22.07.15.12.32.02.52-.1.2-.15.32-.3.5-.15.18-.32.4-.45.54-.15.15-.31.31-.13.62.18.32.81 1.33 1.74 2.16 1.2 1.07 2.21 1.4 2.52 1.55.32.15.51.13.7-.08.2-.22.81-.94 1.03-1.27.22-.32.45-.27.74-.16.3.11 1.88.89 2.2 1.05.32.16.54.24.62.37.07.13.07.78-.18 1.48Z"/>
  </svg>
);

export default function WhatsAppCard({ compact = false }) {
  if (compact) {
    return (
      <a href={CEF_LINKS.whatsapp_channel} target="_blank" rel="noreferrer" className="neo-card p-4 bg-cef-green flex items-center gap-3 hover:no-underline" data-testid="whatsapp-cta-compact">
        <WhatsAppIcon className="w-8 h-8 shrink-0 text-black" />
        <div className="flex-1 min-w-0">
          <div className="font-display font-black text-sm uppercase">Rejoindre le canal WhatsApp</div>
          <div className="text-xs">Échange avec d'autres élèves de la FWB</div>
        </div>
        <span className="neo-btn bg-black text-white text-xs py-1.5 px-2">Ouvrir</span>
      </a>
    );
  }
  return (
    <section className="neo-card p-6 sm:p-8 bg-cef-green" data-testid="whatsapp-section">
      <div className="flex items-start gap-4 flex-wrap">
        <WhatsAppIcon className="w-12 h-12 shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="font-display font-black text-2xl sm:text-3xl tracking-tighter uppercase">Échange sur le canal WhatsApp du CEF</div>
          <p className="mt-2 text-sm sm:text-base">Rejoins des centaines d'élèves de la Fédération Wallonie-Bruxelles sur notre canal WhatsApp officiel. Infos, actions, entraide — directement sur ton téléphone.</p>
          <div className="mt-4 flex flex-wrap gap-3 items-center">
            <a href={CEF_LINKS.whatsapp_channel} target="_blank" rel="noreferrer" className="neo-btn bg-black text-white" data-testid="whatsapp-join-btn">
              <WhatsAppIcon className="w-4 h-4 text-cef-green" /> Rejoindre le canal
            </a>
            <span className="text-xs font-bold uppercase tracking-widest opacity-70">Sur Android · iPhone · WhatsApp Web</span>
          </div>
        </div>
      </div>
    </section>
  );
}
